module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.deal && _vm.deal.id) ? _c('div', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progressTasks),
      expression: "progressTasks"
    }],
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "deal-tasks"
  }, _vm._l((_vm.tasks), function(task, i) {
    return (_vm.tasks && _vm.tasks.length) ? _c('div', {
      key: i,
      staticClass: "deal-tasks__task",
      attrs: {
        "tag": "md-card",
        "md-theme": "white"
      }
    }, [_c('div', {
      staticClass: "deal-tasks__task__top"
    }, [_c('router-link', {
      staticClass: "name",
      attrs: {
        "to": {
          name: 'DealTask',
          params: {
            dealid: _vm.deal.id,
            taskid: task.id
          }
        }
      }
    }, [_vm._v(_vm._s(task.name))])], 1), _c('div', {
      staticClass: "deal-tasks__task__bottom"
    }, [(task.project) ? _c('div', {
      staticClass: "project"
    }, [_vm._v(_vm._s(task.project.name))]) : _vm._e(), (task.responsible) ? _c('div', {
      staticClass: "responsible"
    }, [_vm._v(_vm._s((task.responsible.fio) ? task.responsible.fio : task.responsible.name))]) : _vm._e(), (task.status_section) ? _c('div', {
      staticClass: "status"
    }, [_vm._v(_vm._s(task.status_section.name))]) : _vm._e(), (task.deadline) ? _c('div', {
      staticClass: "deadline"
    }, [_vm._v(_vm._s(_vm.moment(task.deadline).format('DD.MM.YYYY HH:mm')))]) : _vm._e()])]) : _vm._e()
  })), (typeof _vm.tasks == 'undefined' || _vm.tasks.length == 0) ? _c('p', {
    staticClass: "md-caption"
  }, [_vm._v("У заявки нет ни одной задачи")]) : _vm._e(), _c('md-button', {
    attrs: {
      "to": {
        name: 'DealTask',
        params: {
          dealid: _vm.deal.id,
          taskid: 'new'
        }
      }
    }
  }, [_vm._v("Добавить задачу")])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d2bf04d","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/deals/views/components/Tasks.vue
// module id = 1211
// module chunks = 0